import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import './SearchInput.css';

function SearchInput({ filter, buscar }) {
    return (
        <div className={`search-container add-search ${filter ? 'conValor' : ''}`}>
            <FontAwesomeIcon icon={faMagnifyingGlass} className='add-search-cont' style={{ color: '#3D4D87' }} />
            <input
                placeholder='Buscar...'
                className='input-search-txt'
                value={filter}
                onChange={data => buscar(data.target.value)}
            />
        </div>
    );
}

export default SearchInput;
